var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_504_10508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.3651 25.4678C48.3651 23.4193 48.2012 21.9245 47.8463 20.3743H24.7734V29.6201H38.3167C38.0438 31.9178 36.5693 35.3781 33.2926 37.7033L33.2467 38.0128L40.5419 43.7424L41.0473 43.7935C45.6891 39.4474 48.3651 33.0527 48.3651 25.4678Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7732 49.8283C31.4083 49.8283 36.9785 47.6136 41.0471 43.7936L33.2924 37.7032C31.2172 39.1704 28.432 40.1947 24.7732 40.1947C18.2747 40.1947 12.759 35.8487 10.7929 29.8416L10.5047 29.8664L2.91903 35.8181L2.81982 36.0977C6.86095 44.2363 15.1617 49.8283 24.7732 49.8283Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.793 29.8416C10.2743 28.2914 9.97402 26.6303 9.97402 24.9141C9.97402 23.1977 10.2743 21.5368 10.7658 19.9866L10.752 19.6565L3.07127 13.6091L2.81997 13.7303C1.15442 17.1076 0.19873 20.9002 0.19873 24.9141C0.19873 28.928 1.15442 32.7204 2.81997 36.0977L10.793 29.8416Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7733 9.6334C29.3878 9.6334 32.5006 11.6542 34.2755 13.3429L41.211 6.47767C36.9515 2.46374 31.4084 0 24.7733 0C15.1618 0 6.86096 5.59179 2.81982 13.7303L10.7656 19.9866C12.7591 13.9796 18.2747 9.6334 24.7733 9.6334Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_504_10508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.1943,
    height: 50,
    fill: "white",
    transform: "translate(0.196289)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.128b457471ce0961e6d8e6e47a34f4b2.svg";
export { ForwardRef as ReactComponent };